import React, { Fragment, useRef } from 'react';
import { useUpdateEffect } from 'react-use';
import { styled } from 'styled-components';
import { LoginButton } from './LoginButton';
import { MainNavigationLinks } from './MainNavigationLinks';
import { PlayLogo } from './PlayLogo';
import { SearchButton } from './SearchButton';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useRoutes } from '../../../config/VideoAppContext';
import { findRoute } from '../../../models/PlayRoute';
import { QuickSearchOverlay } from '../../../pages/Search/QuickSearch/QuickSearchOverlay';
import { SearchBar } from '../../../pages/Search/SearchBar/SearchBar';
import { useSearchState } from '../../../pages/Search/SearchContext';
import { RemixFocusLock } from '../../ClientOnly/ClientOnly';
import { headerHeight, mobileHeaderHeight } from '../Header.globals';
import { HeaderMenu } from '../HeaderMenu/HeaderMenu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MainNavigationContent = () => {
  const searchFieldRef = useRef(null);
  const routes = useRoutes();
  const analytics = useAnalyticsDispatch();
  const {
    searchOpen,
    searchPageOpen,
    query,
    showAll,
    previousPage
  } = useSearchState();
  const quickSearchVisible = searchOpen && !searchPageOpen || query.searchTerm.trim() === '' && searchPageOpen && !showAll;
  useUpdateEffect(() => {
    if (!quickSearchVisible && (query.searchTerm.trim() !== '' || showAll)) {
      const referrerPage = previousPage ? findRoute(previousPage, routes)?.pageId : undefined;
      analytics({
        type: 'perform-search',
        referrerPage,
        searchTerm: query.searchTerm
      });
    }
  }, [quickSearchVisible]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(Layout, {
      children: [/*#__PURE__*/_jsx(PlayLogo, {}), !searchPageOpen && /*#__PURE__*/_jsx(MainNavigationLinks, {}), /*#__PURE__*/_jsxs(RightContainer, {
        children: [/*#__PURE__*/_jsx(LoginButton, {}), /*#__PURE__*/_jsx(SearchButton, {
          searchFieldRef: searchFieldRef
        }), /*#__PURE__*/_jsx(HeaderMenu, {})]
      })]
    }), /*#__PURE__*/_jsxs(RemixFocusLock, {
      disabled: !quickSearchVisible,
      children: [/*#__PURE__*/_jsx(SearchBar, {
        inputRef: searchFieldRef
      }), quickSearchVisible && /*#__PURE__*/_jsx(QuickSearchOverlay, {})]
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "MainNavigationContent__Layout",
  componentId: "sc-145lnpg-0"
})(["display:flex;align-items:center;position:relative;", ";", "{flex-wrap:wrap;}"], headerHeight, Viewports.for('small'));
const RightContainer = styled.div.withConfig({
  displayName: "MainNavigationContent__RightContainer",
  componentId: "sc-145lnpg-1"
})(["display:grid;grid-auto-flow:column;margin-left:auto;align-items:center;grid-column-gap:8px;", "{min-height:", "px;}"], Viewports.for('small'), mobileHeaderHeight);